module.exports = __webpack_public_path__ + "static/img/betting-history-bg.a88bfe7.png";